import { ShopifyProductImage } from '@portal/types/shopify/common.types';
import { FormattedShopifyProduct } from '@portal/types/shopify/product.formatted.types';
import { RawShopifyProduct } from '@portal/types/shopify/product.raw.types';
import { reshapeToFormattedShopifyVariant } from './reshapeToFormattedShopifyVariant';

export const reshapeToFormattedShopifyProduct = (product: RawShopifyProduct) => {
  return {
    ...product,
    images: product.images.edges.map((edge) => edge.node) as ShopifyProductImage[],
    variants: product?.variants?.nodes.map((node) => reshapeToFormattedShopifyVariant(node)) || []
  } as FormattedShopifyProduct;
};
